export default __webpack_public_path__ + "static/media/logo.0a4c6759.png";